import Vue from 'vue'
import VueRouter from 'vue-router'



import home  from '../views/Home.vue';
// import games  from '../views/Games.vue';
import news  from '../views/News.vue';
import detail  from '../views/Detail.vue';
Vue.use(VueRouter)
const routes = [
{
  path: '/',
  name: 'home',
  // redirect: '/home',
    meta: {
    index: 1
  },
  component:home,
},
// {
//   path: '/home',
//   name: 'home',
//   meta: {
//     index: 1
//   },
//   component:home,
// },
// {
//   path: '/games',
//   name: 'games',
//   meta: {
//     index: 1
//   },
//   component:games
// },
{
  path: '/news',
  name: 'news',
  meta: {
    index: 1
  },
  component:news,
},
{
  path: '/detail',///:index
  name: 'detail',
  meta: {
    index: 1
  },
  component:detail,
}
]
 
const router = new VueRouter({
  mode: 'history',//history   hash
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    // 解决路由跳转后 会滚动到底部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})
 

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default router
 


// WEBPACK FOOTER //
// ./src/router/index.js